import toast from '@ep/tools/toast';
import msgbox from '@ep/tools/msgbox';

/**
 * ELEMENTOS VISUAIS DO TUTORIAL
 *
 * Este arquivo contém somente a configuração dos elementos.
 * Ele NÃO decide onde cada bloco aparece na tela. Essa responsabilidade fica
 * em elements-layout.js.
 *
 * Regra deste tutorial:
 * - image é elemento;
 * - tag é elemento;
 * - button é elemento;
 * - progress / meter é elemento.
 *
 * Todo o restante permanece na família de formulários.
 */

/**
 * IMAGENS
 *
 * `element: 'image'` cria o componente de imagem do EP.
 * `origin` informa de onde o arquivo será resolvido.
 * `src` é o caminho do arquivo.
 * `label` é opcional.
 * `labelPosition` altera a posição da legenda.
 * `hasFigure: false` remove o wrapper semântico de figure quando necessário.
 */
export const images = [
  {
    element: 'image',
    origin: 'media',
    src: '/public/2026/09/19/d1.jpg',
    style: { width: '200px', height: '150px' },
    label: 'Dragão Negro'
  },
  {
    element: 'image',
    origin: 'media',
    src: '/public/2026/09/19/d2.jpeg',
    style: { width: '200px', height: '150px' },
    label: 'Dragão Branco',
    labelPosition: 'top'
  },
  {
    element: 'image',
    origin: 'media',
    src: '/public/2026/09/19/d4.jpg',
    style: { width: '200px', height: '150px' }
  },
  {
    element: 'image',
    origin: 'media',
    src: '/public/2026/09/19/d6.jpg',
    style: { width: '200px', height: '150px' },
    hasFigure: false
  }
];

/**
 * TAGS
 */
export const tags = [
  { element: 'div', text: 'Semânticas' },
  { element: 'br' },
  {
    element: 'div',
    content: [
      { element: 'tag', type: 'info' },
      { element: 'tag', type: 'success' },
      { element: 'tag', type: 'warning' },
      { element: 'tag', type: 'danger' },
      { element: 'tag', type: 'critical' },
      { element: 'tag', type: 'error' },
      { element: 'tag', type: 'muted' },
      { element: 'tag', type: 'value' },
      { element: 'tag', type: 'premium' }
    ]
  },
  { element: 'hr' },
  { element: 'div', text: 'Qualidade / natureza de problema' },
  { element: 'br' },
  {
    element: 'div',
    content: [
      { element: 'tag', type: 'bug' },
      { element: 'tag', type: 'improvement' },
      { element: 'tag', type: 'issue' },
      { element: 'tag', type: 'decision' },
      { element: 'tag', type: 'action' }
    ]
  },
  { element: 'hr' },
  { element: 'div', text: 'Risco / governança' },
  { element: 'br' },
  {
    element: 'div',
    content: [
      { element: 'tag', type: 'risk' },
      { element: 'tag', type: 'dependency' },
      { element: 'tag', type: 'impediment' }
    ]
  },
  { element: 'hr' },
  { element: 'div', text: 'Fluxo / status de trabalho' },
  { element: 'br' },
  {
    element: 'div',
    content: [
      { element: 'tag', type: 'backlog' },
      { element: 'tag', type: 'to-do' },
      { element: 'tag', type: 'in-progress' },
      { element: 'tag', type: 'review' },
      { element: 'tag', type: 'done' },
      { element: 'tag', type: 'blocked' },
      { element: 'tag', type: 'waiting' },
      { element: 'tag', type: 'on-hold' },
      { element: 'tag', type: 'canceled' }
    ]
  },
  { element: 'hr' },
  { element: 'div', text: 'ROAM' },
  { element: 'br' },
  {
    element: 'div',
    content: [
      { element: 'tag', type: 'resolved' },
      { element: 'tag', type: 'owned' },
      { element: 'tag', type: 'accepted' },
      { element: 'tag', type: 'mitigated' }
    ]
  },
  { element: 'hr' },
  { element: 'div', text: 'Status Administrativo' },
  { element: 'br' },
  {
    element: 'div',
    content: [
      { element: 'tag', type: 'active' },
      { element: 'tag', type: 'inactive' },
      { element: 'tag', type: 'pending' },
      { element: 'tag', type: 'suspended' }
    ]
  },
  { element: 'hr' },
  { element: 'div', text: 'Cores' },
  { element: 'br' },
  {
    element: 'div',
    content: [
      { element: 'tag', text: 'Etiqueta 0' },
      { element: 'tag', color: 1, text: 'Etiqueta 1' },
      { element: 'tag', color: 2, text: 'Etiqueta 2' },
      { element: 'tag', color: 3, text: 'Etiqueta 3' },
      { element: 'tag', color: 4, text: 'Etiqueta 4' },
      { element: 'tag', color: 5, text: 'Etiqueta 5' },
      { element: 'tag', color: 6, text: 'Etiqueta 6' },
      { element: 'tag', color: 7, text: 'Etiqueta 7' },
      { element: 'tag', color: 8, text: 'Etiqueta 8' },
      { element: 'tag', color: 9, text: 'Etiqueta 9' },
      { element: 'tag', color: 10, text: 'Etiqueta 10' },
      { element: 'tag', color: 11, text: 'Etiqueta 11' },
      { element: 'tag', color: 12, text: 'Etiqueta 12' }
    ]
  },
  { element: 'hr' },
  { element: 'div', text: 'Cores Customizadas' },
  { element: 'br' },
  {
    element: 'div',
    content: [
      { element: 'tag', color: 'navy', text: 'Etiqueta 13' },
      { element: 'tag', color: 'rgb(186,157,200)', text: 'Etiqueta 14' },
      { element: 'tag', color: '#ff6000', text: 'Etiqueta 15' },
      { element: 'tag', color: 'white', text: 'Etiqueta 16' }
    ]
  }
];

/**
 * PROGRESS E METER
 */
export const progressBars = [
  { element: 'progress', id: 'prog', value: 0, style: 'width: 250px;', label: 'Progresso', row: 0, col: 0 },
  { element: 'progress', id: 'prog2', value: 0, style: 'width: 250px;', type: 'meter', label: 'Meter', labels: ['Total'], row: 0, col: 1 },
  { element: 'progress', id: 'prog4', value: 0, max: 24, style: 'width: 250px;', label: 'Progresso', percentual: false, row: 1, col: 0 },
  {
    element: 'progress',
    id: 'prog3',
    value: [0, 0, 0, 0],
    style: 'width: 500px;',
    type: 'meter',
    label: 'Meter',
    labels: [
      { icon: { type: 'solid', name: 'table-cells-large' }, text: 'Apps' },
      { icon: { type: 'solid', name: 'envelope' }, text: 'Messages' },
      { icon: { type: 'solid', name: 'image' }, text: 'Media' },
      { icon: { type: 'solid', name: 'gear' }, text: 'System' }
    ],
    row: 2,
    col: 0,
    colspan: 2
  }
];

/**
 * BOTÕES PADRÃO
 */
export const buttonsDefault = [
  { element: 'button', row: 0, col: 0, text: 'Toast - Error', color: 'red', icon: { type: 'solid', name: 'bomb' }, click: () => { toast({ type: 'error', message: 'Esta aqui é uma mensagem de erro' }); } },
  { element: 'button', row: 0, col: 1, text: 'Toast - Warning', color: 'yellow', icon: { type: 'solid', name: 'triangle-exclamation' }, click: () => { toast({ type: 'warning', message: 'Esta aqui é uma mensagem de alerta' }); } },
  { element: 'button', row: 0, col: 2, text: 'Toast - Info', icon: { type: 'solid', name: 'circle-info' }, click: () => { toast({ type: 'info', message: '<p>Esta é uma mensagem de informação!</p><br><p>Vale a pena lembrar que isso aqui ainda é uma vesão beta.</p>' }); } },
  { element: 'button', row: 0, col: 3, text: 'Toast - Success', color: 'green', icon: { type: 'solid', name: 'check' }, click: () => { toast({ type: 'success', message: 'Se já chegou aqui pode ter certeza que é sucesso' }); } },
  { element: 'button', row: 0, col: 4, text: 'Toast - Default', click: () => { toast({ message: 'Tinha alguma coisa pra dizer, mas enfim...' }); } },
  { element: 'button', row: 1, col: 0, text: 'Box - Error', color: 'red', icon: { type: 'solid', name: 'bomb' }, click: () => { msgbox({ type: 'error', message: 'Esta é uma mensagem de erro.' }); } },
  { element: 'button', row: 1, col: 1, text: 'Box - Warning', color: 'yellow', icon: { type: 'solid', name: 'triangle-exclamation' }, click: () => { msgbox({ type: 'warning', message: 'Esta aqui é uma mensagem de alerta' }); } },
  { element: 'button', row: 1, col: 2, text: 'Box - Info', icon: { type: 'solid', name: 'circle-info' }, click: () => { msgbox({ type: 'info', message: '<p>Esta é uma mensagem de informação!</p><br><p>Vale a pena lembrar que isso aqui ainda é uma vesão beta.</p>' }); } },
  { element: 'button', row: 1, col: 3, text: 'Box - Question', color: 'green', icon: { type: 'solid', name: 'circle-question' }, click: () => { msgbox({ type: 'question', message: 'Esta é uma pergunta', click: () => { alert('OK'); } }); } },
  { element: 'button', row: 1, col: 4, text: 'Box - YN', color: 'green', icon: { type: 'solid', name: 'circle-question' }, click: () => { msgbox({ type: 'yn', message: 'Esta é uma pergunta', click: () => { alert('SIM'); }, nclick: () => { alert('NÃO'); } }); } },
  {
    element: 'button', row: 1, col: 5, text: 'Box - Custom', color: 'green', icon: { type: 'solid', name: 'circle-question' }, click: () => {
      msgbox({
        type: 'question', message: 'O que deseja fazer?', buttons: [
          { text: 'Continuar', color: 'blue', click: () => { alert('Continue'); } },
          { text: 'Reiniciar', color: 'green', click: () => { alert('Restart'); } },
          { text: 'Abortar', color: 'red', click: () => { alert('Abort'); } }
        ]
      });
    }
  },
  { element: 'button', row: 2, col: 0, text: 'Box - Success', color: 'green', icon: { type: 'solid', name: 'check' }, click: () => { msgbox({ type: 'success', message: 'Se já chegou aqui pode ter certeza que é sucesso' }); } },
  { element: 'button', row: 2, col: 2, text: 'Box - Default', click: () => { msgbox({ message: 'Mensagem comum' }); } },
  {
    element: 'button', row: 2, col: 4, text: 'Box - Form', click: () => {
      create([
        {
          element: 'form',
          parent: 'body',
          isDialog: true,
          title: 'Alteração de Senha',
          service: 'accounts.alterPassword',
          isGrid: true,
          content: [
            { element: 'password', label: 'Digite a senha', row: 0, col: 0, strength: true },
            { element: 'password', label: 'Confirme a senha', row: 1, col: 0 }
          ]
        }
      ]);
    }
  }
];

/**
 * BOTÕES FILLED
 *
 * Repetido por inteiro de propósito para o trecho ser copiável sozinho.
 */
export const buttonsFilled = [
  { element: 'button', row: 0, col: 0, text: 'Toast - Error', mode: 'filled', color: 'red', icon: { type: 'solid', name: 'bomb' }, click: () => { toast({ type: 'error', message: 'Esta aqui é uma mensagem de erro' }); } },
  { element: 'button', row: 0, col: 1, text: 'Toast - Warning', mode: 'filled', color: 'yellow', icon: { type: 'solid', name: 'triangle-exclamation' }, click: () => { toast({ type: 'warning', message: 'Esta aqui é uma mensagem de alerta' }); } },
  { element: 'button', row: 0, col: 2, text: 'Toast - Info', mode: 'filled', icon: { type: 'solid', name: 'circle-info' }, click: () => { toast({ type: 'info', message: '<p>Esta é uma mensagem de informação!</p><br><p>Vale a pena lembrar que isso aqui ainda é uma vesão beta.</p>' }); } },
  { element: 'button', row: 0, col: 3, text: 'Toast - Success', mode: 'filled', color: 'green', icon: { type: 'solid', name: 'check' }, click: () => { toast({ type: 'success', message: 'Se já chegou aqui pode ter certeza que é sucesso' }); } },
  { element: 'button', row: 0, col: 4, text: 'Toast - Default', mode: 'filled', click: () => { toast({ message: 'Tinha alguma coisa pra dizer, mas enfim...' }); } },
  { element: 'button', row: 1, col: 0, text: 'Box - Error', mode: 'filled', color: 'red', icon: { type: 'solid', name: 'bomb' }, click: () => { msgbox({ type: 'error', message: 'Esta é uma mensagem de erro.' }); } },
  { element: 'button', row: 1, col: 1, text: 'Box - Warning', mode: 'filled', color: 'yellow', icon: { type: 'solid', name: 'triangle-exclamation' }, click: () => { msgbox({ type: 'warning', message: 'Esta aqui é uma mensagem de alerta' }); } },
  { element: 'button', row: 1, col: 2, text: 'Box - Info', mode: 'filled', icon: { type: 'solid', name: 'circle-info' }, click: () => { msgbox({ type: 'info', message: '<p>Esta é uma mensagem de informação!</p><br><p>Vale a pena lembrar que isso aqui ainda é uma vesão beta.</p>' }); } },
  { element: 'button', row: 1, col: 3, text: 'Box - Question', mode: 'filled', color: 'green', icon: { type: 'solid', name: 'circle-question' }, click: () => { msgbox({ type: 'question', message: 'Esta é uma pergunta', click: () => { alert('OK'); } }); } },
  { element: 'button', row: 1, col: 4, text: 'Box - YN', mode: 'filled', color: 'green', icon: { type: 'solid', name: 'circle-question' }, click: () => { msgbox({ type: 'yn', message: 'Esta é uma pergunta', click: () => { alert('SIM'); }, nclick: () => { alert('NÃO'); } }); } },
  {
    element: 'button', row: 1, col: 5, text: 'Box - Custom', mode: 'filled', color: 'green', icon: { type: 'solid', name: 'circle-question' }, click: () => {
      msgbox({
        type: 'question', message: 'O que deseja fazer?', buttons: [
          { text: 'Continuar', color: 'blue', click: () => { alert('Continue'); } },
          { text: 'Reiniciar', color: 'green', click: () => { alert('Restart'); } },
          { text: 'Abortar', color: 'red', click: () => { alert('Abort'); } }
        ]
      });
    }
  },
  { element: 'button', row: 2, col: 0, text: 'Box - Success', mode: 'filled', color: 'green', icon: { type: 'solid', name: 'check' }, click: () => { msgbox({ type: 'success', message: 'Se já chegou aqui pode ter certeza que é sucesso' }); } },
  { element: 'button', row: 2, col: 2, text: 'Box - Default', mode: 'filled', click: () => { msgbox({ message: 'Mensagem comum' }); } },
  {
    element: 'button', row: 2, col: 4, text: 'Box - Form', mode: 'filled', click: () => {
      create([
        {
          element: 'form',
          parent: 'body',
          isDialog: true,
          title: 'Alteração de Senha',
          service: 'accounts.alterPassword',
          isGrid: true,
          content: [
            { element: 'password', label: 'Digite a senha', row: 0, col: 0, strength: true },
            { element: 'password', label: 'Confirme a senha', row: 1, col: 0 }
          ]
        }
      ]);
    }
  }
];

/**
 * BOTÕES HOLLOW
 *
 * Também repetido por inteiro para não esconder propriedades em outro bloco.
 */
export const buttonsHollow = [
  { element: 'button', row: 0, col: 0, text: 'Toast - Error', mode: 'hollow', color: 'red', icon: { type: 'solid', name: 'bomb' }, click: () => { toast({ type: 'error', message: 'Esta aqui é uma mensagem de erro' }); } },
  { element: 'button', row: 0, col: 1, text: 'Toast - Warning', mode: 'hollow', color: 'yellow', icon: { type: 'solid', name: 'triangle-exclamation' }, click: () => { toast({ type: 'warning', message: 'Esta aqui é uma mensagem de alerta' }); } },
  { element: 'button', row: 0, col: 2, text: 'Toast - Info', mode: 'hollow', icon: { type: 'solid', name: 'circle-info' }, click: () => { toast({ type: 'info', message: '<p>Esta é uma mensagem de informação!</p><br><p>Vale a pena lembrar que isso aqui ainda é uma vesão beta.</p>' }); } },
  { element: 'button', row: 0, col: 3, text: 'Toast - Success', mode: 'hollow', color: 'green', icon: { type: 'solid', name: 'check' }, click: () => { toast({ type: 'success', message: 'Se já chegou aqui pode ter certeza que é sucesso' }); } },
  { element: 'button', row: 0, col: 4, text: 'Toast - Default', mode: 'hollow', click: () => { toast({ message: 'Tinha alguma coisa pra dizer, mas enfim...' }); } },
  { element: 'button', row: 1, col: 0, text: 'Box - Error', mode: 'hollow', color: 'red', icon: { type: 'solid', name: 'bomb' }, click: () => { msgbox({ type: 'error', message: 'Esta é uma mensagem de erro.' }); } },
  { element: 'button', row: 1, col: 1, text: 'Box - Warning', mode: 'hollow', color: 'yellow', icon: { type: 'solid', name: 'triangle-exclamation' }, click: () => { msgbox({ type: 'warning', message: 'Esta aqui é uma mensagem de alerta' }); } },
  { element: 'button', row: 1, col: 2, text: 'Box - Info', mode: 'hollow', icon: { type: 'solid', name: 'circle-info' }, click: () => { msgbox({ type: 'info', message: '<p>Esta é uma mensagem de informação!</p><br><p>Vale a pena lembrar que isso aqui ainda é uma vesão beta.</p>' }); } },
  { element: 'button', row: 1, col: 3, text: 'Box - Question', mode: 'hollow', color: 'green', icon: { type: 'solid', name: 'circle-question' }, click: () => { msgbox({ type: 'question', message: 'Esta é uma pergunta', click: () => { alert('OK'); } }); } },
  { element: 'button', row: 1, col: 4, text: 'Box - YN', mode: 'hollow', color: 'green', icon: { type: 'solid', name: 'circle-question' }, click: () => { msgbox({ type: 'yn', message: 'Esta é uma pergunta', click: () => { alert('SIM'); }, nclick: () => { alert('NÃO'); } }); } },
  {
    element: 'button', row: 1, col: 5, text: 'Box - Custom', mode: 'hollow', color: 'green', icon: { type: 'solid', name: 'circle-question' }, click: () => {
      msgbox({
        type: 'question', message: 'O que deseja fazer?', buttons: [
          { text: 'Continuar', color: 'blue', click: () => { alert('Continue'); } },
          { text: 'Reiniciar', color: 'green', click: () => { alert('Restart'); } },
          { text: 'Abortar', color: 'red', click: () => { alert('Abort'); } }
        ]
      });
    }
  },
  { element: 'button', row: 2, col: 0, text: 'Box - Success', mode: 'hollow', color: 'green', icon: { type: 'solid', name: 'check' }, click: () => { msgbox({ type: 'success', message: 'Se já chegou aqui pode ter certeza que é sucesso' }); } },
  { element: 'button', row: 2, col: 2, text: 'Box - Default', mode: 'hollow', click: () => { msgbox({ message: 'Mensagem comum' }); } },
  {
    element: 'button', row: 2, col: 4, text: 'Box - Form', mode: 'hollow', click: () => {
      create([
        {
          element: 'form',
          parent: 'body',
          isDialog: true,
          title: 'Alteração de Senha',
          service: 'accounts.alterPassword',
          isGrid: true,
          content: [
            { element: 'password', label: 'Digite a senha', row: 0, col: 0, strength: true },
            { element: 'password', label: 'Confirme a senha', row: 1, col: 0 }
          ]
        }
      ]);
    }
  }
];

/**
 * Timers ativos da demonstração de progress/meter.
 * Reiniciar a aba deve reiniciar também a animação, sem acumular intervals.
 */
let progressTimers = [];

const stopProgressBars = () => {
  progressTimers.forEach((timer) => clearInterval(timer));
  progressTimers = [];
};

const resetProgressBars = () => {
  document.getElementById('prog')?.val(0);
  document.getElementById('prog2')?.val(0);
  document.getElementById('prog4')?.val(0);
  document.getElementById('prog3')?.val([0, 0, 0, 0]);
};

/**
 * Anima os exemplos de progress/meter quando a aba Elementos está visível.
 */
export const startProgressBars = () => {
  stopProgressBars();
  resetProgressBars();

  const t = setInterval(() => {
    const o = document.getElementById('prog');
    if (o) {
      const v = o.val();
      if (parseFloat(v) === 100) {
        clearInterval(t);
        return;
      }
      o.val(parseFloat(v) + 1);
    }
  }, 200);
  progressTimers.push(t);

  const u = setInterval(() => {
    const o = document.getElementById('prog2');
    if (o) {
      const v = o.val();
      if (parseFloat(v) === 75) {
        clearInterval(u);
        return;
      }
      o.val(parseFloat(v) + 1);
    }
  }, 200);
  progressTimers.push(u);

  const w = setInterval(() => {
    const o = document.getElementById('prog4');
    if (o) {
      const v = o.val();
      if (parseFloat(v) === 24) {
        clearInterval(w);
        return;
      }
      o.val(parseFloat(v) + 1);
    }
  }, 200);
  progressTimers.push(w);

  const y = setInterval(() => {
    const o = document.getElementById('prog3');
    if (!o) return;

    const v = o.val();
    v[0] = parseFloat(v[0]);
    v[1] = parseFloat(v[1]);
    v[2] = parseFloat(v[2]);
    v[3] = parseFloat(v[3]);

    if (parseFloat(v[2]) === 24) {
      clearInterval(y);
      return;
    }

    if (v[0] < 16) v[0] += 1;
    if (v[1] < 8) v[1] += 1;
    if (v[2] < 24) v[2] += 1;
    if (v[3] < 10) v[3] += 1;

    o.val(v);
  }, 200);
  progressTimers.push(y);
};
